import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.5, strokeLinecap: "round", ref, ...props }, /* @__PURE__ */ React.createElement(Path, { d: "M5 12l14 0", strokeLinecap: "round", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
